import { render } from "./VolunteerSignUpStats.vue?vue&type=template&id=c2ac3a78&scoped=true"
import script from "./VolunteerSignUpStats.vue?vue&type=script&lang=js"
export * from "./VolunteerSignUpStats.vue?vue&type=script&lang=js"

import "./VolunteerSignUpStats.vue?vue&type=style&index=0&id=c2ac3a78&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2ac3a78"]])

export default __exports__